export const PRD_HOSTNAME = 'mex-crm.grab.com';
export const STG_HOSTNAME = 'mex-crm.stg-myteksi.com';
export const DEV_HOSTNAME = 'mex-crm.grab.dev';
export const MEX_PORTAL_PRD_HOSTNAME = 'merchant.grab.com';
export const MEX_PORTAL_STG_HOSTNAME = 'merchant.stg-myteksi.com';
export const MEX_PORTAL_DEV_HOSTNAME = 'merchant.dev.stg-myteksi.com';

export const STG_API_ENDPOINT = 'https://stg.abc.com';
export const PRD_API_ENDPOINT = 'https://prd.abc.com';

export const CONCEDO_CLIENT_ID = 'mex-crm';

export const HEADER_HEIGHT = 70;

export const CHOPE_CRM_PATH = '/crm/chope';
